var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypographyLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330.989,
    height: 83.516,
    viewBox: "0 0 330.989 83.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.176,
    y1: 0.153,
    x2: 1.7,
    y2: 1.603,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d9ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#2b3da7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b1240"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(-80 -66.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M170.928,82.484l-.068-12.541-6.085,10.209H161.8l-6.051-9.871v12.2h-6.186V58.821h5.51l8.316,13.657L171.5,58.821h5.51l.068,23.663Z",
    transform: "translate(36.117 37.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M215.972,77.14H202.653a3.727,3.727,0,0,0,1.572,2.18,5.247,5.247,0,0,0,2.924.761,6.31,6.31,0,0,0,2.281-.372,6.717,6.717,0,0,0,1.944-1.217l3.38,3.516q-2.671,2.975-7.808,2.975a12.471,12.471,0,0,1-5.645-1.216,9.251,9.251,0,0,1-.2-16.5,11.539,11.539,0,0,1,10.141-.084,8.618,8.618,0,0,1,3.533,3.279,9.636,9.636,0,0,1,1.3,5.088q0,.068-.1,1.588m-12.153-5.679a3.816,3.816,0,0,0-1.268,2.3h7.5a3.819,3.819,0,0,0-1.268-2.3,4.075,4.075,0,0,0-4.969,0",
    transform: "translate(21.971 35.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M240.1,66.677a9.688,9.688,0,0,1,3.6-.625v5.78a13.14,13.14,0,0,0-1.454-.1,4,4,0,0,0-4.394,4.529v8.417h-6.423V66.356h6.118v2.2a5.987,5.987,0,0,1,2.552-1.876",
    transform: "translate(11.283 35.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M255.316,59.622a3.279,3.279,0,0,1,0-4.868,4.065,4.065,0,0,1,2.839-.98,4.206,4.206,0,0,1,2.84.93,3,3,0,0,1,1.081,2.383A3.277,3.277,0,0,1,261,59.605a4.573,4.573,0,0,1-5.68.017m-.372,3.009h6.423V80.953h-6.423Z",
    transform: "translate(4.363 39.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M284.672,82.286a6.487,6.487,0,0,1-1.978.777,10.973,10.973,0,0,1-2.485.27,7.892,7.892,0,0,1-5.51-1.758,6.739,6.739,0,0,1-1.928-5.24V70.183H270.1v-4.8h2.67V60.617H279.2v4.766h4.191v4.8H279.2v6.085a2.155,2.155,0,0,0,.524,1.538,1.831,1.831,0,0,0,1.4.558,3.4,3.4,0,0,0,1.961-.575Z",
    transform: "translate(-0.449 37.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M305.328,63.993V69.2h10.446v5.172H305.328v8.114h-6.693V58.821h18.559v5.172Z",
    transform: "translate(-9.105 37.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M331.356,59.622a3.28,3.28,0,0,1,0-4.868,4.068,4.068,0,0,1,2.84-.98,4.205,4.205,0,0,1,2.839.93,3,3,0,0,1,1.081,2.383,3.277,3.277,0,0,1-1.081,2.518,4.573,4.573,0,0,1-5.68.017m-.372,3.009h6.423V80.953h-6.423Z",
    transform: "translate(-18.705 39.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M366.334,68.08q2.078,2.028,2.079,6.118V84.677H361.99V75.246q0-3.752-3.009-3.752a3.436,3.436,0,0,0-2.654,1.082,4.645,4.645,0,0,0-1,3.245v8.857h-6.423V66.355h6.119V68.35a7.28,7.28,0,0,1,2.569-1.707,8.716,8.716,0,0,1,3.245-.591,7.531,7.531,0,0,1,5.494,2.029",
    transform: "translate(-24.357 35.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M404.511,56.783V81.866h-6.119V80.04a6.629,6.629,0,0,1-5.375,2.13A9.106,9.106,0,0,1,388.454,81a8.434,8.434,0,0,1-3.262-3.33,10.993,10.993,0,0,1,0-9.99,8.341,8.341,0,0,1,3.262-3.3,9.21,9.21,0,0,1,4.564-1.149,6.648,6.648,0,0,1,5.071,1.893V56.783Zm-7.4,19.116a4.565,4.565,0,0,0,1.082-3.228,4.5,4.5,0,0,0-1.065-3.178,3.586,3.586,0,0,0-2.755-1.149,3.639,3.639,0,0,0-2.772,1.149,4.454,4.454,0,0,0-1.082,3.178A4.565,4.565,0,0,0,391.6,75.9a3.611,3.611,0,0,0,2.772,1.166,3.575,3.575,0,0,0,2.738-1.166",
    transform: "translate(-35 38.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M439.919,77.14H426.6a3.727,3.727,0,0,0,1.572,2.18,5.249,5.249,0,0,0,2.924.761,6.316,6.316,0,0,0,2.282-.372,6.723,6.723,0,0,0,1.944-1.217l3.38,3.516q-2.67,2.975-7.809,2.975a12.471,12.471,0,0,1-5.645-1.216,9.251,9.251,0,0,1-.2-16.5,11.539,11.539,0,0,1,10.141-.084,8.622,8.622,0,0,1,3.533,3.279,9.63,9.63,0,0,1,1.3,5.088q0,.068-.1,1.588m-12.153-5.679a3.807,3.807,0,0,0-1.267,2.3H434a3.825,3.825,0,0,0-1.267-2.3,4.076,4.076,0,0,0-4.97,0",
    transform: "translate(-45.969 35.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M464.045,66.677a9.689,9.689,0,0,1,3.6-.625v5.78a13.14,13.14,0,0,0-1.454-.1,4,4,0,0,0-4.4,4.529v8.417h-6.422V66.356h6.118v2.2a5.983,5.983,0,0,1,2.552-1.876",
    transform: "translate(-56.656 35.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M49.052,83.516V78.144h3.205a5.384,5.384,0,0,0,2.688-.719L81.792,61.918a5.374,5.374,0,0,0,2.688-4.653V26.252A5.376,5.376,0,0,0,81.792,21.6L54.945,6.09a5.386,5.386,0,0,0-2.688-.719h-3.2V0h3.207a10.776,10.776,0,0,1,5.374,1.437L84.479,16.944a10.753,10.753,0,0,1,5.376,9.308V57.265a10.731,10.731,0,0,1-5.376,9.307L57.633,82.08a10.775,10.775,0,0,1-5.374,1.436Zm-11.454,0a10.777,10.777,0,0,1-5.375-1.436L5.376,66.572A10.732,10.732,0,0,1,0,57.265V26.252a10.753,10.753,0,0,1,5.376-9.308L32.223,1.437A10.779,10.779,0,0,1,37.6,0H40.8V5.372H37.6a5.384,5.384,0,0,0-2.688.719L8.064,21.6a5.378,5.378,0,0,0-2.688,4.655V57.265a5.376,5.376,0,0,0,2.688,4.653L34.911,77.425a5.382,5.382,0,0,0,2.688.719H40.8v5.372Zm12.123-37.7H40.114a14.756,14.756,0,1,1,.09-5.964H49.63a14.759,14.759,0,1,1,.09,5.964Zm3.506-3.2A10.893,10.893,0,1,0,64.118,31.721,10.905,10.905,0,0,0,53.226,42.613Zm-38.4,0A10.893,10.893,0,1,0,25.716,31.721,10.905,10.905,0,0,0,14.823,42.613Zm43.472,0a5.824,5.824,0,1,1,5.824,5.824A5.83,5.83,0,0,1,58.295,42.613Zm-38.4,0a5.823,5.823,0,1,1,5.824,5.824A5.83,5.83,0,0,1,19.892,42.613Z",
    transform: "translate(80 66.252)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypographyLogoLight);
export default __webpack_public_path__ + "static/media/TypographyLogoLight.7ac2c3868beb71c29ea0fc24a8d2edb8.svg";
export { ForwardRef as ReactComponent };